import React, { Component } from 'react';
import { TextArea } from 'devextreme-react';
import i18n from '../../i18n';
import ReeValidate from 'ree-validate';
import vi from 'ree-validate/dist/locale/vi';
import en from 'ree-validate/dist/locale/en';
import PropTypes from 'prop-types';

class DescriptionBox extends Component {
    constructor(props) {
        super(props);

        this.validator = new ReeValidate({
            description: this.props.validatorValue
        });

        if (this.props.currentLanguage === 'vi-VN') {
            this.validator.localize('vi', vi);
        } else {
            this.validator.localize('en', en);
        }

        this.validator.validate('description', this.props.value).then(() => {
            this.checkValidate();
        });

        this.valueChanged = this.valueChanged.bind(this);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.validator.validate('description', nextProps.value).then(() => {
                this.checkValidate();
            });
        }
    }

    valueChanged = (e) => {
        if (e.event !== undefined && e.event !== null) {
            if (e.event.type !== 'dxclick') {
                const { errors } = this.validator;

                errors.remove(e.event.target.name);
                this.props.updateData({
                    [this.props.field]: e.event.target.value
                });

                this.validator
                    .validate(e.event.target.name, e.event.target.value)
                    .then(() => {
                        this.setState({ errors });

                        const formValidate = !errors.has('description');
                        this.props.updateData({
                            formValidate
                        });
                    })
                    .catch(() => { });
            }
        }
    };

    checkValidate() {
        const { field } = this.props;

        const formValidate = !this.validator.errors.has('description');
        this.props.updateData({
            formValidate: { [field]: formValidate }
        });
    }

    render() {
        const { value, i18nLabel, validatorValue, readOnly } = this.props;

        return (
            <div
                className={'' + (this.validator.errors.has('description') ? ' has-error' : '')}
            >
                <div className={'dx-field'}>
                    <div className={'dx-field-label'}>
                        {i18n.t(i18nLabel) + ':'}
                        {!readOnly && validatorValue &&
                            validatorValue.includes('require') && (<span className="color-red"> *</span>)}
                    </div>
                    <div className={'dx-field-value'}>
                        <TextArea
                            className={'multi-language'}
                            name={'description'}
                            valueChangeEvent={'keyup'}
                            value={value}
                            onValueChanged={this.valueChanged}
                            readOnly={readOnly || false}
                        />
                        {this.validator.errors.has('description') && (
                            <div className="help-block">
                                {this.validator.errors
                                    .first('description')
                                    .replace('description', i18n.t(i18nLabel))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

DescriptionBox.propTypes = {
    value: PropTypes.any,
    i18nLabel: PropTypes.string,
    validatorValue: PropTypes.string,
    readOnly: PropTypes.bool,
    updateData: PropTypes.any,
    field: PropTypes.any,
    currentLanguage: PropTypes.any
};

export default DescriptionBox;
